export const getMapListOfProviders = (providers, list) => {
    if (!list) {
        list = [];
    }

    if (providers && providers.length > 0) {
        providers.forEach(item => {
            const prov = item.provider;
            if (prov.locations && prov.locations.length > 0) {
                prov.locations.forEach(loc => {
                    const coords = loc.coordinates;                   
                    if (coords && coords.lat !== 0 && coords.lon !== 0) {
                        list.push({
                            key: list.length,
                            data: prov,
                            name: prov.displayName,
                            locationId: loc.locationID,
                            latitude: coords.lat,
                            longitude: coords.lon,
                            type: 'provider'
                        });
                    }
                });
            }
        });
    }
};

export const getMapListOfLocations = (locations, list) => {
    if (!list) {
        list = [];
    }

    if (locations && locations.length > 0) {
        locations.forEach(loc => {
            const coords = loc.coordinates;
            if (coords.lat !== 0 && coords.lon !== 0) {
                list.push({
                    key: list.length,
                    data: loc,
                    name: loc.locationName,
                    locationId: loc.locationID,
                    latitude: coords.lat,
                    longitude: coords.lon,
                    type: 'location'
                });
            }
        });
    }
};

export const groupByLocation = (list) => {
    let i = 0;
    while (i < list.length) {
        const item1 = list[i];
        const latitude1 = item1.latitude;
        const longitude1 = item1.longitude;
        item1.group = [{ id: item1.id, type: item1.type, locationId: item1.locationId, data: item1.data }];
        let j = i + 1;
        while (j < list.length) {
            const item2 = list[j];
            if (item2.latitude === latitude1 && item2.longitude === longitude1) {
                item1.group.push({ id: item2.id, type: item2.type, locationId: item2.locationId, data: item2.data });
                list.splice(j, 1);
            }
            else {
                j++;
            }
        }
        i++;
    }
};

export const indexOf = (list, type) => {
    if (list) {
        for (let i = 0; i < list.length; i++) {
            const item = list[i];
            if (item.type === type) {
                return i;
            }
            else if (item.group.length > 1) {
                const group = item.group;
                for (let j = 0; j < group.length; j++) {
                    if (group[j].type === type) {
                        return j;
                    }
                }
            }
        }
    }

    return null;
};